(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Menú móvil ---------- */
  var burger = $('[data-burger]'), drawerNav = $('[data-drawer]');
  function setMenu(open) {
    if (!burger || !drawerNav) return;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawerNav.hidden = !open;
  }
  if (burger && drawerNav) {
    burger.addEventListener('click', function () { setMenu(burger.getAttribute('aria-expanded') !== 'true'); });
    drawerNav.addEventListener('click', function (e) { if (e.target.closest('a,button')) setMenu(false); });
  }

  /* ---------- Ventanas emergentes ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { setMenu(false); openDialog(document.getElementById(o.getAttribute('data-open'))); return; }
    var c = e.target.closest('[data-close]');
    if (c) { var dl = c.closest('dialog'); if (dl) dl.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  // Tras enviar un formulario de Shopify, la página recarga con #id: reabrimos su ventana con el mensaje
  var hash = window.location.hash.replace('#', '');
  if (hash) {
    var form = document.getElementById(hash);
    var dlg = form && form.closest('dialog');
    var msg = form && $('[data-posted]', form);
    if (dlg && msg) {
      msg.hidden = false;
      $$('[data-fields]', form).forEach(function (n) { n.hidden = true; });
      openDialog(dlg);
    }
  }

  /* ---------- Valoraciones: leer más ---------- */
  $$('[data-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.previousElementSibling, open = p.classList.toggle('open');
      b.textContent = open ? b.getAttribute('data-l-less') : b.getAttribute('data-l-more');
    });
  });

  /* ---------- Carrito lateral (API Ajax de Shopify) ---------- */
  var cartEl = $('[data-cart]'), shade = $('[data-shade]'), itemsEl = $('[data-items]');
  var cartData = null;
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (err) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function openCart() { if (!cartEl) return; cartEl.classList.add('on'); shade.classList.add('on'); cartEl.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!cartEl) return; cartEl.classList.remove('on'); shade.classList.remove('on'); cartEl.setAttribute('aria-hidden', 'true'); }
  function paint(c) {
    cartData = c;
    $$('[data-count]').forEach(function (n) { n.textContent = c.item_count; n.hidden = !c.item_count; });
    if (!itemsEl) return;
    var h = '';
    c.items.forEach(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? '<br><small style="font-weight:400;color:var(--c-muted)">' + esc(it.variant_title) + '</small>' : '';
      h += '<div class="ci"><b>' + esc(it.product_title) + v + '</b><b>' + money(it.final_line_price) + '</b>' +
        '<span class="q"><button type="button" data-dec="' + esc(it.key) + '" aria-label="' + esc(itemsEl.dataset.dec) + '">−</button><span>' + it.quantity +
        '</span><button type="button" data-inc="' + esc(it.key) + '" aria-label="' + esc(itemsEl.dataset.inc) + '">+</button></span>' +
        '<button class="rm" type="button" data-rm="' + esc(it.key) + '">' + esc(itemsEl.dataset.remove) + '</button></div>';
    });
    itemsEl.innerHTML = h || '<p class="empty">' + esc(itemsEl.dataset.empty) + '</p>';
    $('[data-total]').textContent = money(c.total_price);
    var co = $('[data-checkout]');
    if (co) { co.setAttribute('aria-disabled', c.item_count ? 'false' : 'true'); co.style.opacity = c.item_count ? '' : '.5'; }
  }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(key, qty) {
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(paint);
  }
  function add(id, btn) {
    if (btn) btn.disabled = true;
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(getCart).then(function (c) { paint(c); openCart(); })
      .catch(function () { window.location.href = ROOT + 'cart'; })
      .then(function () { if (btn) btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add-variant]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-add-variant'), a); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); getCart().then(paint); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target === shade) { closeCart(); return; }
    var co = e.target.closest('[data-checkout]');
    if (co && co.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var b = e.target.closest('[data-inc],[data-dec],[data-rm]');
    if (b && cartData) {
      var key = b.getAttribute('data-inc') || b.getAttribute('data-dec') || b.getAttribute('data-rm');
      var item = cartData.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      change(key, b.hasAttribute('data-inc') ? item.quantity + 1 : b.hasAttribute('data-dec') ? item.quantity - 1 : 0);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); if (burger && drawerNav && !drawerNav.hidden) { setMenu(false); burger.focus(); } }
  });

  /* ---------- Cantidades (producto y carrito) ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentNode.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    var v = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
    input.value = Math.max(isNaN(min) ? 1 : min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Ordenar colección ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Ficha de producto: galería y variantes ---------- */
  var section = $('[data-product-section]');
  if (!section) return;
  var main = $('[data-main-img]', section);
  $$('[data-thumb]', section).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) { main.removeAttribute('srcset'); main.src = btn.getAttribute('data-thumb'); }
      $$('[data-thumb]', section).forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });
  var variantsEl = $('[data-variants]', section), labelsEl = $('[data-labels]', section), pform = $('[data-product-form]', section);
  if (!variantsEl || !pform) return;
  var variants = JSON.parse(variantsEl.textContent), labels = labelsEl ? JSON.parse(labelsEl.textContent) : {};
  var idInput = $('[data-variant-id]', pform), pbtn = $('[data-add-btn]', pform), priceEl = $('[data-price]', section);
  var optionInputs = $$('[data-option-input]', pform);
  function update() {
    var vals = [];
    optionInputs.forEach(function (i) { if (i.checked) vals[parseInt(i.getAttribute('data-option-input'), 10)] = i.value; });
    var match = variants.filter(function (v) { return v.options.every(function (o, idx) { return o === vals[idx]; }); })[0];
    if (!match) { pbtn.disabled = true; pbtn.textContent = labels.unavailable || ''; return; }
    idInput.value = match.id;
    pbtn.disabled = !match.available;
    pbtn.textContent = match.available ? labels.add : labels.sold;
    if (priceEl) priceEl.innerHTML = (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s> ' : '') + money(match.price);
    var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }
  optionInputs.forEach(function (i) { i.addEventListener('change', update); });
})();
